<template>
  <div class="md-card md-card-nav-tabs">
    <div class="md-card-content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "nav-tabs-card",
};
</script>
